module.exports = __webpack_public_path__ + "b7ccdd1813cc0c04493d0da1de23669f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/houses.png
// module id = 549
// module chunks = 0